"use strict";
/**
 * SAT Catalog Constants for CFDI Nómina (Payroll)
 *
 * Based on SAT catalogs for electronic payroll invoicing (CFDI 4.0)
 * These codes are required for CFDI compliance in Mexico.
 *
 * @see SAT Catalogs: http://omawww.sat.gob.mx/tramitesyservicios/Paginas/anexo_20_version3-3.htm
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAT_RESOURCE_ORIGINS_ARRAY = exports.SAT_RESOURCE_ORIGIN_LABELS = exports.SATResourceOrigin = exports.SAT_WORK_RISK_CLASSES_ARRAY = exports.SAT_WORK_RISK_CLASS_LABELS = exports.SATWorkRiskClass = exports.SAT_FISCAL_REGIMES_ARRAY = exports.SAT_FISCAL_REGIME_LABELS = exports.SATFiscalRegime = exports.SAT_PAYMENT_FREQUENCIES_ARRAY = exports.SAT_PAYMENT_FREQUENCY_LABELS = exports.SATPaymentFrequency = exports.SAT_JOURNEY_TYPES_ARRAY = exports.SAT_JOURNEY_TYPE_LABELS = exports.SATJourneyType = exports.SAT_REGIME_TYPES_ARRAY = exports.SAT_REGIME_TYPE_LABELS = exports.SATRegimeType = exports.SAT_CONTRACT_TYPES_ARRAY = exports.SAT_CONTRACT_TYPE_LABELS = exports.SATContractType = void 0;
// ============================================================================
// Contract Type (c_TipoContrato)
// ============================================================================
/**
 * SAT Contract Type codes (c_TipoContrato)
 */
exports.SATContractType = {
    Permanent: '01',
    Temporary: '02',
    SeasonOrCycle: '03',
    Training: '04',
    InitialTraining: '05',
    HomeBased: '06',
    TrialPeriod: '07',
    RetiredPayments: '08',
    Retirement: '09',
    Other: '99',
};
/**
 * Contract type labels in Spanish for UI dropdowns
 */
exports.SAT_CONTRACT_TYPE_LABELS = {
    '01': 'Contrato de trabajo por tiempo indeterminado',
    '02': 'Contrato de trabajo para obra determinada',
    '03': 'Contrato de trabajo por temporada',
    '04': 'Contrato de trabajo sujeto a prueba',
    '05': 'Contrato de trabajo con capacitación inicial',
    '06': 'Modalidad de contratación por pago de hora laborada',
    '07': 'Modalidad de trabajo por comisión laboral',
    '08': 'Modalidad de contratación donde no existe relación de trabajo',
    '09': 'Jubilación, pensión, retiro',
    '99': 'Otro contrato',
};
/**
 * Contract types array for dropdowns
 */
exports.SAT_CONTRACT_TYPES_ARRAY = Object.entries(exports.SAT_CONTRACT_TYPE_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Regime Type (c_TipoRegimen)
// ============================================================================
/**
 * SAT Regime Type codes (c_TipoRegimen)
 * Employment regime types for payroll
 */
exports.SATRegimeType = {
    Salaries: '02',
    Retirement: '03',
    Pensions: '04',
    Assimilated: '05',
    BoardMembers: '06',
    Fees: '07',
    CommissionAgents: '08',
    AssimilatedOther: '09',
    Retirement402: '10',
    Syndicate: '11',
    Severance: '12',
    DeathBenefit: '13',
};
/**
 * Regime type labels in Spanish for UI dropdowns
 */
exports.SAT_REGIME_TYPE_LABELS = {
    '02': 'Sueldos (Incluye ingresos señalados en la fracción I del artículo 94 de LISR)',
    '03': 'Jubilados',
    '04': 'Pensionados',
    '05': 'Asimilados Miembros Sociedades Cooperativas Producción',
    '06': 'Asimilados Integrantes Sociedades Asociaciones Civiles',
    '07': 'Asimilados Honorarios',
    '08': 'Asimilados comisionistas',
    '09': 'Asimilados Otros',
    '10': 'Asimilados obtengan ingresos acciones',
    '11': 'Asimilados ingresos sindicatos',
    '12': 'Indemnizaciones o Separaciones',
    '13': 'Subsidios por incapacidad',
};
/**
 * Regime types array for dropdowns
 */
exports.SAT_REGIME_TYPES_ARRAY = Object.entries(exports.SAT_REGIME_TYPE_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Journey Type (c_TipoJornada)
// ============================================================================
/**
 * SAT Journey/Workday Type codes (c_TipoJornada)
 */
exports.SATJourneyType = {
    Day: '01',
    Night: '02',
    Mixed: '03',
    ByHour: '04',
    Reduced: '05',
    Continuous: '06',
    Split: '07',
    ByTurn: '08',
    Other: '99',
};
/**
 * Journey type labels in Spanish for UI dropdowns
 */
exports.SAT_JOURNEY_TYPE_LABELS = {
    '01': 'Diurna',
    '02': 'Nocturna',
    '03': 'Mixta',
    '04': 'Por hora',
    '05': 'Reducida',
    '06': 'Continuada',
    '07': 'Partida',
    '08': 'Por turnos',
    '99': 'Otra jornada',
};
/**
 * Journey types array for dropdowns
 */
exports.SAT_JOURNEY_TYPES_ARRAY = Object.entries(exports.SAT_JOURNEY_TYPE_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Payment Frequency (c_PeriodicidadPago)
// ============================================================================
/**
 * SAT Payment Frequency codes (c_PeriodicidadPago)
 */
exports.SATPaymentFrequency = {
    Daily: '01',
    Weekly: '02',
    Biweekly: '03',
    Quincenal: '04',
    Monthly: '05',
    Bimonthly: '06',
    ByUnit: '07',
    ByCommission: '08',
    ByPrice: '09',
    Decennial: '10',
    Other: '99',
};
/**
 * Payment frequency labels in Spanish for UI dropdowns
 */
exports.SAT_PAYMENT_FREQUENCY_LABELS = {
    '01': 'Diario',
    '02': 'Semanal',
    '03': 'Catorcenal',
    '04': 'Quincenal',
    '05': 'Mensual',
    '06': 'Bimestral',
    '07': 'Unidad obra',
    '08': 'Comisión',
    '09': 'Precio alzado',
    '10': 'Decenal',
    '99': 'Otra periodicidad',
};
/**
 * Payment frequencies array for dropdowns
 */
exports.SAT_PAYMENT_FREQUENCIES_ARRAY = Object.entries(exports.SAT_PAYMENT_FREQUENCY_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Fiscal Regime for Employees (c_RegimenFiscal)
// ============================================================================
/**
 * SAT Fiscal Regime codes for employees (c_RegimenFiscal)
 * Subset of fiscal regimes applicable to payroll
 */
exports.SATFiscalRegime = {
    SalariesAndWages: '605',
    WithoutFiscalObligations: '616',
};
/**
 * Fiscal regime labels in Spanish for UI dropdowns
 */
exports.SAT_FISCAL_REGIME_LABELS = {
    '605': 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
    '616': 'Sin obligaciones fiscales',
};
/**
 * Fiscal regimes array for dropdowns
 */
exports.SAT_FISCAL_REGIMES_ARRAY = Object.entries(exports.SAT_FISCAL_REGIME_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Work Risk Class (c_RiesgoPuesto)
// ============================================================================
/**
 * SAT Work Risk Class codes (c_RiesgoPuesto)
 * IMSS risk classification for the workplace
 */
exports.SATWorkRiskClass = {
    ClassI: '1',
    ClassII: '2',
    ClassIII: '3',
    ClassIV: '4',
    ClassV: '5',
};
/**
 * Work risk class labels in Spanish for UI dropdowns
 */
exports.SAT_WORK_RISK_CLASS_LABELS = {
    '1': 'Clase I - Riesgo ordinario',
    '2': 'Clase II - Riesgo bajo',
    '3': 'Clase III - Riesgo medio',
    '4': 'Clase IV - Riesgo alto',
    '5': 'Clase V - Riesgo máximo',
};
/**
 * Work risk classes array for dropdowns
 */
exports.SAT_WORK_RISK_CLASSES_ARRAY = Object.entries(exports.SAT_WORK_RISK_CLASS_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
// ============================================================================
// Resource Origin (c_OrigenRecurso)
// ============================================================================
/**
 * SAT Resource Origin codes (c_OrigenRecurso)
 * Origin of funds for certain payment types
 */
exports.SATResourceOrigin = {
    IncomePayment: 'IP',
    FederalResources: 'IF',
    MixedIncome: 'IM',
};
/**
 * Resource origin labels in Spanish for UI dropdowns
 */
exports.SAT_RESOURCE_ORIGIN_LABELS = {
    IP: 'Ingresos propios',
    IF: 'Ingresos federales',
    IM: 'Ingresos mixtos',
};
/**
 * Resource origins array for dropdowns
 */
exports.SAT_RESOURCE_ORIGINS_ARRAY = Object.entries(exports.SAT_RESOURCE_ORIGIN_LABELS).map(([code, label]) => ({
    code: code,
    label,
}));
